$(document).ready(function() {

  $(".posts--pagination-more").on('click',function(e) {
    e.preventDefault();
    var paged = parseFloat( $(this).attr('data-next') );
    updatePostsResults(paged);
  });

	var updatePostsResults = function( paged ) {

    paged            = paged ? paged : 1;
    var grid         = $('.news-grid');

    console.log(paged);

    $.ajax({
      type     : "post",
      dataType : "json",
      url      : localized_object.ajax_url,
      data : {
        action : "get_posts_form",
        data   : {'paged' : paged},
        nonce  : localized_object.nonce,
        paged  : paged
      },
      timeout    : 300000,
      beforeSend : function() {

      }
    }).done( function( response ) {

      if ( response && typeof response.news !== 'undefined' ) {

       	var count = $('.cur-num').text();
        count = parseFloat(count) + parseFloat(response.displaying);

        var newPosts = $( response.news );
        grid.append(newPosts);

        $(".posts--pagination-more").attr('data-next', response.cur_page + 1 );
        $('.cur-num').html(count);
        $('.max-num').html(parseFloat(response.max_count));

        if ( response.cur_page < response.max_pages ) {
          $(".posts--pagination-more").show();
        } else {
          $(".posts--pagination-more").hide();
        }

		  }

    }).fail( function( request, status, err ) {

       console.log( 'REQUEST => ' + request );
       console.log( 'STATUS => ' + status );
       console.log( 'ERR => ' );
       console.log( err );

    }).always(function() {



    });

  }

});
